import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DashboardComponent } from './public-module/dashboard/dashboard.component';
import { WelcomeLoginComponent } from './public-module/welcome-login/welcome-login.component';
import { ResetPasswordComponent } from './auth-module/reset-password/reset-password.component';
import { WelcomeLoginGuard } from './public-module/guards/welcome-login.guard';
import { AdminRoutingModule } from './admin/admin-routing.module';
import { ResetPasswordGuard } from './auth-module/guards/reset-password.guard';
import { RedirectGuard } from './public-module/guards/redirect.guard';
import { EmptyRouteGuard } from './public-module/guards/empty-route.guard';
const routes: Routes = [
  { path: '', component: DashboardComponent, canActivate: [EmptyRouteGuard] },
  { path: 'dashboard', component: DashboardComponent, canActivate: [RedirectGuard]},
  { path: 'welcome-login', component: WelcomeLoginComponent, canActivate : [WelcomeLoginGuard]},
  {path: 'reset-password', component: ResetPasswordComponent, canActivate: [ResetPasswordGuard]},
  { path: 'login', loadChildren: () => import('./auth-module/auth-routing.module').then(m => m.AuthRoutingModule) },
  { path: 'admin', loadChildren: () => import('./admin/admin-routing.module').then(m => m.AdminRoutingModule) },
  {
    path: '',
    redirectTo: '',
    pathMatch: 'full'
  },
  {
    path: '**',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
